export default __webpack_public_path__ + "static/media/dernekhomepic.82448fa2.jpg";